import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import type { ReactNode } from 'react';

interface AuthGuardProps {
  children: ReactNode;
  redirectTo?: string;
}

export default function AuthGuard({ children, redirectTo = '/auth' }: AuthGuardProps) {
  const { isLoggedIn, status } = useAuth();
  const location = useLocation();

  if (status === 'authenticating') {
    return null;
  }

  if (!isLoggedIn) {
    const state = { from: location.pathname + location.search };
    return <Navigate to={redirectTo} state={state} replace />;
  }

  return <>{children}</>;
}
